var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    { style: { width: "100%" } },
    [
      _c(
        "w-col",
        { staticClass: "qty-col", attrs: { lg: "2", sm: "4", xs: "12" } },
        [
          _c(
            "w-row",
            { attrs: { "no-margin": "", "no-padding": "", "no-wrap": "" } },
            [
              _vm.state.duration > 0 || _vm.state.toggleTimePicker
                ? _c("app-duration", {
                    style: { flexGrow: 1, flexShrink: 1 },
                    attrs: {
                      label: _vm.$ct("sales-row.Duration"),
                      value: _vm.state.duration,
                      fancy: "",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.setDuration($event)
                      },
                    },
                  })
                : _c("w-input-number", {
                    ref: "qty",
                    style: { flexGrow: 1, flexShrink: 1 },
                    attrs: {
                      value: _vm.state.amount1,
                      decimals: _vm.decimalSettings.Qty,
                      label: _vm.qtyLabel,
                      fancy: "",
                      autofocus: _vm.autoFocusQty,
                      disabled: _vm.isDisabled("qty"),
                    },
                    on: {
                      input: function ($event) {
                        return _vm.state.setAmount1($event)
                      },
                      keyup: [
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.onQtyEnter($event)
                        },
                        function ($event) {
                          return _vm.onFocusableKeyUpRowSelect($event)
                        },
                      ],
                      keydown: [
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                          )
                            return null
                          return _vm.onQtyEnter($event)
                        },
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "t",
                              undefined,
                              $event.key,
                              undefined
                            )
                          )
                            return null
                          return _vm.onTemplateKey($event)
                        },
                        function ($event) {
                          return _vm.onNumericKeyDown(
                            $event,
                            "qty",
                            _vm.decimalSettings.Qty
                          )
                        },
                      ],
                    },
                  }),
              _c(
                "w-dropdown",
                {
                  style: { padding: "7px 5px", flexShrink: 0 },
                  attrs: {
                    items: _vm.qtyActions,
                    flat: "",
                    center: "",
                    right: "",
                  },
                  on: {
                    click: function ($event) {
                      if (
                        $event.ctrlKey ||
                        $event.shiftKey ||
                        $event.altKey ||
                        $event.metaKey
                      )
                        return null
                      return _vm.trigger($event)
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "chevron-down", size: "xs" } })],
                1
              ),
              _vm.showDeliveredField
                ? _c("w-input-number", {
                    ref: "delivered",
                    style: { flexGrow: 1, flexShrink: 1 },
                    attrs: {
                      decimals: _vm.decimalSettings.Qty,
                      label: _vm.$ct("sales-row.Delivered"),
                      fancy: "",
                      autofocus: _vm.autoFocusQty,
                      disabled: _vm.isDisabled("delivered"),
                    },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.onDeliveredEnter($event)
                      },
                    },
                    model: {
                      value: _vm.state.delivered,
                      callback: function ($$v) {
                        _vm.$set(_vm.state, "delivered", $$v)
                      },
                      expression: "state.delivered",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { lg: _vm.productSkuLg, sm: _vm.productSkuSm, xs: "12" } },
        [
          _c(
            "div",
            {
              staticClass: "sku-search",
              class: { compact: _vm.compact },
              staticStyle: { position: "relative" },
            },
            [
              _c("app-product-sku-autocomplete", {
                ref: "productSku",
                attrs: {
                  value: _vm.state.product,
                  state: _vm.state,
                  "create-modal-if-not-exist": "",
                  "auto-focus": _vm.autoFocusSku,
                  "allow-multiple": "",
                  "remove-on-empty": "",
                  "show-stock-location": _vm.showStockLocationId,
                  disabled: _vm.isDisabled("productSku"),
                },
                on: {
                  fetching: function ($event) {
                    _vm.fetchingProduct = $event
                  },
                  input: function ($event) {
                    return _vm.onProductSkuSelect($event)
                  },
                  inputs: function ($event) {
                    return _vm.onMultipleProductsSkuSelect($event)
                  },
                  keyup: function ($event) {
                    return _vm.onFocusableKeyUp($event)
                  },
                },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.onProductSkuEnter()
                  },
                  keydown: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                    )
                      return null
                    return _vm.onProductSkuTab($event)
                  },
                },
              }),
            ],
            1
          ),
        ]
      ),
      _vm.showQty2
        ? _c(
            "w-col",
            { attrs: { lg: 1, sm: "3", xs: "12" } },
            [
              _c("w-input-number", {
                ref: "qty2",
                attrs: {
                  decimals: _vm.decimalSettings.Qty2,
                  disabled: _vm.isDisabled("qty2"),
                  label: _vm.qty2Label,
                  fancy: "",
                },
                on: {
                  input: function ($event) {
                    return _vm.state.setAmount2($event)
                  },
                  keyup: [
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.onQty2Enter($event)
                    },
                    function ($event) {
                      return _vm.onFocusableKeyUp($event)
                    },
                  ],
                  keydown: [
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                      )
                        return null
                      return _vm.onQty2Enter($event)
                    },
                    function ($event) {
                      return _vm.onNumericKeyDown(
                        $event,
                        "qty2",
                        _vm.decimalSettings.Qty2
                      )
                    },
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k(
                          $event.keyCode,
                          "t",
                          undefined,
                          $event.key,
                          undefined
                        )
                      )
                        return null
                      return _vm.onTemplateKey($event)
                    },
                  ],
                },
                model: {
                  value: _vm.state.amount2,
                  callback: function ($$v) {
                    _vm.$set(_vm.state, "amount2", $$v)
                  },
                  expression: "state.amount2",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.showUnits
        ? _c(
            "w-col",
            { attrs: { lg: "1", sm: "3", xs: "12" } },
            [
              _c("app-unit-autocomplete", {
                ref: "unit",
                attrs: {
                  label: _vm.unitLabel,
                  disabled: _vm.isDisabled("unit"),
                  "has-error": !_vm.unitValid,
                  fancy: "",
                  lang: _vm.lng,
                },
                on: {
                  keyup: [
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.onUnitEnter($event)
                    },
                    function ($event) {
                      return _vm.onFocusableKeyUp($event)
                    },
                  ],
                },
                model: {
                  value: _vm.state.unit,
                  callback: function ($$v) {
                    _vm.$set(_vm.state, "unit", $$v)
                  },
                  expression: "state.unit",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.showTrackingNUmber
        ? _c(
            "w-col",
            { attrs: { lg: "2", sm: "3", xs: "12" } },
            [
              _c("w-input", {
                ref: "trackingNumber",
                attrs: {
                  label: _vm.$ct("tracking-number"),
                  "has-error": !_vm.trackingNumberValid,
                  fancy: "",
                  lang: _vm.lng,
                  disabled: _vm.state.product == null,
                  icon: "search",
                },
                on: {
                  "icon-click": function ($event) {
                    _vm.state.trackingNumberEditModal = true
                  },
                  keyup: [
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.onTrackingNumberEnter($event)
                    },
                    function ($event) {
                      return _vm.onFocusableKeyUp($event)
                    },
                  ],
                },
                model: {
                  value: _vm.state.trackingNumber,
                  callback: function ($$v) {
                    _vm.$set(_vm.state, "trackingNumber", $$v)
                  },
                  expression: "state.trackingNumber",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.showSizeSelect
        ? _c(
            "w-col",
            { attrs: { lg: "2", sm: "3", xs: "12" } },
            [
              _c("w-select", {
                ref: "sizeTableEntry",
                attrs: {
                  items: _vm.sizeOptions,
                  label: _vm.$ct("size"),
                  disabled: _vm.state.product == null,
                  fancy: "",
                },
                model: {
                  value: _vm.state.sizeTableEntryID,
                  callback: function ($$v) {
                    _vm.$set(_vm.state, "sizeTableEntryID", $$v)
                  },
                  expression: "state.sizeTableEntryID",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-col",
        { attrs: { lg: _vm.descriptionLg, xs: "12" } },
        [
          _c("app-input-with-textarea-modal", {
            ref: "productDescription",
            attrs: {
              label: _vm.$ct("sales-row.Name"),
              fancy: "",
              "modal-title": _vm.$ct("sales-row.Name"),
              editor: true,
              disabled: _vm.isDisabled("productDescription"),
            },
            on: {
              keyup: [
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.onProductDescriptionBlur()
                },
                function ($event) {
                  return _vm.onKeyPress($event)
                },
              ],
              confirm: function ($event) {
                return _vm.onDescriptionChange()
              },
            },
            model: {
              value: _vm.state.productDescription,
              callback: function ($$v) {
                _vm.$set(_vm.state, "productDescription", $$v)
              },
              expression: "state.productDescription",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { lg: "2", md: "5", xs: "6" } },
        [
          _c("w-input-number", {
            ref: "unitPrice",
            attrs: {
              decimals: _vm.decimalSettings.Unit,
              label: _vm.$ct("sales-row.UnitPrice"),
              value: _vm.isDefaultCurrency
                ? _vm.state.unitPrice
                : _vm.state.unitPriceMc,
              disabled: _vm.isDisabled("unitPrice"),
              fancy: "",
            },
            on: {
              input: function ($event) {
                return _vm.setUnitPrice($event)
              },
              keyup: [
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.onUnitPriceBlur()
                },
                function ($event) {
                  return _vm.onFocusableKeyUp($event)
                },
              ],
              keydown: function ($event) {
                return _vm.onUnitPriceKeydown($event)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { lg: "1-and-half", md: "3-and-half", xs: "6" } },
        [
          _c("app-sale-edit-row-discount", {
            ref: "discount",
            attrs: {
              "sale-edit-state": _vm.saleEditState,
              disabled: _vm.discountsDisabled || _vm.isDisabled("discount"),
            },
            on: {
              keydown: function ($event) {
                return _vm.onDiscountKeydown($event)
              },
              keyup: [
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.onDiscountBlur()
                },
                function ($event) {
                  return _vm.onFocusableKeyUp($event)
                },
              ],
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { lg: "1-and-half", md: "3-and-half", xs: "12" } },
        [
          _c("app-vat-select", {
            ref: "vatItems",
            attrs: {
              label: _vm.$ct("sales-row.Vat"),
              fancy: "",
              "use-object": "",
              "create-new-enabled": "",
              disabled: _vm.vatRegime == 2 || _vm.isDisabled("vatItems"),
            },
            nativeOn: {
              keyup: [
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.onVatItemsBlur()
                },
                function ($event) {
                  return _vm.onFocusableKeyUp($event)
                },
              ],
              mouseup: function ($event) {
                return _vm.checkVatRegime.apply(null, arguments)
              },
            },
            model: {
              value: _vm.state.vatItem,
              callback: function ($$v) {
                _vm.$set(_vm.state, "vatItem", $$v)
              },
              expression: "state.vatItem",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        {
          style: { display: "flex", flexDirection: "row" },
          attrs: { lg: "7", xs: "12" },
        },
        [
          _c("w-input-number", {
            ref: "netto",
            style: { marginRight: "15px", flexGrow: 1 },
            attrs: {
              decimals: _vm.decimalSettings.Unit,
              label: _vm.$ct("sales-row.NettoPrice"),
              value: _vm.isDefaultCurrency
                ? _vm.state.netto
                : _vm.state.nettoMc,
              fancy: "",
              disabled: _vm.isDisabled("netto"),
            },
            on: {
              input: function ($event) {
                return _vm.setNetto($event)
              },
              keyup: [
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.onNettoBlur()
                },
                function ($event) {
                  return _vm.onFocusableKeyUp($event)
                },
              ],
              keydown: function ($event) {
                return _vm.onNumericKeyDown(
                  $event,
                  "netto",
                  _vm.decimalSettings.Unit
                )
              },
            },
          }),
          _vm.hasLeeggoedModule
            ? _c("w-input-number", {
                ref: "leeggoed",
                style: { marginRight: "15px", flexGrow: 1 },
                attrs: {
                  decimals: _vm.decimalSettings.Unit,
                  label: _vm.$ct("sales-row.Leeggoed"),
                  value: _vm.state.leeggoedTax,
                  fancy: "",
                  disabled: _vm.isDisabled("leeggoed"),
                },
                on: {
                  keyup: [
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.onLeeggoedBlur()
                    },
                    function ($event) {
                      return _vm.onFocusableKeyUp($event)
                    },
                  ],
                  input: function ($event) {
                    return _vm.setLeeggoed($event)
                  },
                  keydown: function ($event) {
                    return _vm.onNumericKeyDown(
                      $event,
                      "leeggoed",
                      _vm.decimalSettings.Unit
                    )
                  },
                },
              })
            : _vm._e(),
          _c(
            "w-row",
            {
              style: { flexWrap: "nowrap", flexGrow: 1 },
              attrs: { "no-padding": "" },
            },
            [
              _vm.isDefaultCurrency
                ? _c("w-input-number", {
                    ref: "bruto",
                    style: { flexGrow: 1, flexShrink: 1, marginRight: "10px" },
                    attrs: {
                      label: _vm.$ct("sales-row.BrutoPrice"),
                      value: _vm.state.bruto,
                      disabled: _vm.isDisabled("bruto"),
                      fancy: "",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.setBruto($event)
                      },
                      focus: function ($event) {
                        return _vm.onBrutoFocus()
                      },
                      blur: function ($event) {
                        return _vm.onBrutoBlur()
                      },
                      keyup: [
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.onBrutoKeyUpEnter()
                        },
                        function ($event) {
                          return _vm.onFocusableKeyUp($event)
                        },
                      ],
                      keydown: function ($event) {
                        return _vm.onNumericKeyDown(
                          $event,
                          "bruto",
                          _vm.decimalSettings.Bruto
                        )
                      },
                    },
                  })
                : _c("w-input-number", {
                    ref: "bruto",
                    style: { flexGrow: 1, flexShrink: 1, marginRight: "10px" },
                    attrs: {
                      label: _vm.$ct("sales-row.BrutoPrice"),
                      value: _vm.state.brutoMc,
                      disabled: _vm.isDisabled("bruto"),
                      fancy: "",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.setBruto($event)
                      },
                      focus: function ($event) {
                        return _vm.onBrutoFocus()
                      },
                      blur: function ($event) {
                        return _vm.onBrutoBlur()
                      },
                      keyup: [
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.onBrutoKeyUpEnter()
                        },
                        function ($event) {
                          return _vm.onFocusableKeyUp($event)
                        },
                      ],
                      keydown: function ($event) {
                        return _vm.onNumericKeyDown(
                          $event,
                          "bruto",
                          _vm.decimalSettings.Bruto
                        )
                      },
                    },
                  }),
              _c(
                "w-button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$ct("tooltip.add-row"),
                      expression: "$ct('tooltip.add-row')",
                    },
                  ],
                  ref: "buttonAdd",
                  staticClass: "buttonAddSalesRow",
                  style: { flexShrink: 0 },
                  attrs: { lg: "", round: "", disabled: _vm.addButtonDisabled },
                  on: {
                    click: function ($event) {
                      return _vm.add()
                    },
                    keyup: function ($event) {
                      return _vm.onFocusableKeyUp($event)
                    },
                  },
                  nativeOn: {
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                      )
                        return null
                      return _vm.add()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "plus" } })],
                1
              ),
              _c("input", {
                staticStyle: {
                  position: "absolute",
                  left: "-10000px",
                  top: "-500px",
                },
                attrs: { type: "text" },
                on: {
                  focus: function ($event) {
                    return _vm.focusQty()
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.toggleCalculator,
            callback: function ($$v) {
              _vm.toggleCalculator = $$v
            },
            expression: "toggleCalculator",
          },
        },
        [
          _c("app-calculator", {
            attrs: { decimals: _vm.calculatorDecimals },
            on: {
              cancel: function ($event) {
                _vm.toggleCalculator = false
              },
              input: function ($event) {
                return _vm.updateCalculatorRef($event)
              },
            },
          }),
        ],
        1
      ),
      _vm.state.trackingNumberEditModal
        ? _c("app-sale-edit-row-tracking-number-select", {
            attrs: { state: _vm.saleEditState, "row-edit-state": _vm.state },
            on: {
              input: function ($event) {
                _vm.state.trackingNumber = $event
              },
              close: function ($event) {
                _vm.state.trackingNumberEditModal = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }